import React from 'react';

export const name = 'flag-LT';

export const FlagLT = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_2_300"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path d="M24 0H0V24H24V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_2_300)">
      <path
        d="M23.25 16.1718C24.2505 13.4806 24.2505 10.5194 23.25 7.82809L12 6.78278L0.749999 7.82809C-0.250549 10.5194 -0.250549 13.4806 0.749999 16.1718L12 17.2172L23.25 16.1718Z"
        fill="#6DA544"
      />
      <path
        d="M23.25 7.82812C22.3976 5.53158 20.8627 3.55095 18.8516 2.15229C16.8406 0.753628 14.4496 0.00393677 12 0.00393677C9.55036 0.00393677 7.15941 0.753628 5.14838 2.15229C3.13728 3.55095 1.60243 5.53158 0.75 7.82812H23.25Z"
        fill="#FFDA44"
      />
      <path
        d="M12 24C14.4501 23.9997 16.8414 23.2494 18.8525 21.85C20.8636 20.4506 22.3982 18.4691 23.25 16.1719H0.75C1.60179 18.4691 3.13636 20.4506 5.14748 21.85C7.15861 23.2494 9.54989 23.9997 12 24Z"
        fill="#D80027"
      />
    </g>
  </svg>
);
